if (window.location.pathname === "/soplado/periodo" || window.location.pathname === "/zona-trabajo") {

    document.addEventListener('click', function (e) {
        const btnModalFinalizarTurnoSoplado = e.target.closest('#btnModalFinalizarReporteSoplado');
        if (!btnModalFinalizarTurnoSoplado) return;

        const formProduccion = document.querySelector("#formProduccionSoplado");
        const modalFinalizar = document.querySelector("#modalFinalizarTurnoSoplado");

        if (!formProduccion || !modalFinalizar) return;

        const inputReporte = formProduccion.querySelector("#idReporteSoplado");
        const inputIdEncabezado = modalFinalizar.querySelector("#idEncabezadoReporteSoplado");

        if (!inputReporte || !inputIdEncabezado) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan datos para finalizar el turno.", "alerta-roja");
            }
            return;
        }

        inputIdEncabezado.value = inputReporte.value || "";
    });


    document.addEventListener('submit', async function (e) {
        if (e.target.id !== 'formFinalizarTurnoSoplado') return;

        const botonActivo = e.submitter;

        if (!botonActivo || botonActivo.id !== 'btnFinalizarTurnoSoplado') {
            return;
        }

        e.preventDefault();

        const formulario = e.target;
        const modalProduccionSoplado = document.querySelector("#modalProduccionSoplado");
        const modalPadre = formulario.closest('.modal');
        const btnFinalizar = botonActivo;
        const spinner = btnFinalizar.querySelector('#spinner') || formulario.querySelector('#spinner');

        if (!formulario.checkValidity()) {
            formulario.reportValidity();
            return;
        }

        if (btnFinalizar) btnFinalizar.disabled = true;
        if (spinner) spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(function (input) {
            input.classList.remove('inputRojo');
        });

        try {
            const formData = new FormData(formulario, botonActivo);

            const respuesta = await fetch('/api/soplado/finalizar-turno-soplado', {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            let json = null;

            try {
                json = await respuesta.json();
            } catch (errorJson) {
                throw new Error('La respuesta del servidor no es JSON válido.');
            }

            if (!respuesta.ok) {
                console.error('Error HTTP:', respuesta.status, json);

                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta('Error al finalizar el turno.', 'alerta-roja');
                } else {
                    alert('Error al finalizar el turno.');
                }

                return;
            }

            if (!json || !json.result) {
                console.error('Respuesta inesperada:', json);

                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
                }

                return;
            }

            const resultado = json.result;

            if (resultado.hayErrores) {
                if (Array.isArray(resultado.errores)) {
                    resultado.errores.forEach(function (error) {
                        if (typeof lanzarAlerta === 'function') {
                            lanzarAlerta(
                                error.mensaje || 'Error de validación.',
                                error.clase || 'alerta-roja'
                            );
                        }

                        if (error.campo) {
                            const campo = formulario.querySelector('[name="' + error.campo + '"]');
                            if (campo) campo.classList.add('inputRojo');
                        }
                    });
                }

                return;
            }

            const idReporteInput = formulario.querySelector('#idEncabezadoReporteSoplado');
            const idReporte = idReporteInput ? idReporteInput.value : '';

            const params = new URLSearchParams(window.location.search);
            const mes = params.get("mes");
            const anio = params.get("año");

            if (modalPadre) modalPadre.classList.remove('modal--show');
            if (modalProduccionSoplado) modalProduccionSoplado.classList.remove('modal--show');

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Turno finalizado con éxito.", "alerta-verde");
            }

            if (typeof window.actualizarModalReporteSoplado === 'function' && idReporte) {
                window.actualizarModalReporteSoplado(idReporte);
            }

            if (typeof window.actualizarTableroSopladoPeriodo === 'function') {
                window.actualizarTableroSopladoPeriodo(mes, anio);
            }

            if (typeof window.actualizarTablaSopladoPeriodo === 'function') {
                window.actualizarTablaSopladoPeriodo(mes, anio);
            }
            if (typeof window.actualizarZonaTrabajo === 'function') {
                if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
            }


        } catch (error) {
            console.error("Error:", error);

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Error crítico al procesar la solicitud.", "alerta-roja");
            } else {
                alert("Error crítico al procesar la solicitud.");
            }

        } finally {
            if (btnFinalizar) btnFinalizar.disabled = false;
            if (spinner) spinner.style.display = 'none';
        }
    });
}